// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2s2aA","cell":"ColumnAccessor_cell__2XHHM","firstCellAccent":"ColumnAccessor_firstCellAccent__1JZqL"};